
import React, { useState, useEffect, useMemo, useRef } from 'react';

import { HiOutlineSearch } from "react-icons/hi";


import ControlOverlay from "./ControlOverlay";
import Popup from 'reactjs-popup';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { escapeForRgex } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import CalendarLegend from "./CalendarLegend";

const localizer = momentLocalizer(moment);
    


    
    const CalendarView = ({ events, currentDate, onNavigate }) => {
    const [selectedControl, setSelectedControl] = useState(null);
    // Use prop currentDate if provided, otherwise fallback to state
    const [internalDate, setInternalDate] = useState(new Date());
    const activeDate = currentDate || internalDate;
    const setActiveDate = onNavigate || setInternalDate;
    const containerRef = useRef(null);
    const [cellSize, setCellSize] = useState(90); 
    const transformedEvents = events.flatMap((control) => {
        const start = new Date(control.startDate || Date.now());
        const end = new Date(control.endDate || Date.now());

        
        const addMonths = (date, months) => {
            const d = new Date(date);
            d.setMonth(d.getMonth() + months);
            return d;
        };
        const addDays = (date, days) => {
            const d = new Date(date);
            d.setDate(d.getDate() + days);
            return d;
        };

        ////////console.log("Not shown Control", control)
        if(control.secondLine === 0){
            //////console.log("Not shown Control", control)
            return []
        }
        //const keys = Object.keys(control);
        ////////console.log(keys)
        if (control.controlPeriod === "Monthly" || control.controlPeriod === "Quarterly" || control.controlPeriod === "Weekly") {
            const eventList = [];
            let current = new Date(start);
            //////console.log("Monthly")
            const repeatEnd =  new Date();
            repeatEnd.setDate(end.getDate() + 365)
            let daysonRepeat = 0
            let end_c = new Date(end)
            while(current <= repeatEnd ){
                daysonRepeat = 0
                
                
                eventList.push({
                    title: control.controlDetails || "No Title",
                    start: new Date(current),
                    end: new Date(end_c), 
                    allDay: true,
                    controlID: control.controlID,
                    riskId: control.riskId,
                    controlType: control.controlType || null
                });

                    
                if (control.controlPeriod === "Monthly") {
                    current = addMonths(current, 1);
                   end_c = addMonths(end_c, 1)
                }else if(control.controlPeriod === "Quarterly"){
                    current = addMonths(current, 3);
                    end_c = addMonths(end_c, 3)
                }else {
                    current = addDays(current, 7);
                    end_c = addDays(end_c, 7)
                }
            
        }

            return eventList;
        }
        
        
        // Default (single event)
        return [
            {
                title: control.controlDetails || "No Title",
                start: start,
                end: end,
                allDay: true,
                controlID: control.controlID,
                riskId: control.riskId,
                controlType: control.controlType || null
            }
        ];
    });

    const handleEventClick = (event) => {
        //////console.log("Picked Contorl", event)
        setSelectedControl(event);
    };

    const currentMonthLabel = useMemo(() => {
        const m = moment(activeDate);
        return `${m.format("MMMM")} ${m.format("YYYY")}`;
    }, [activeDate]);

    const monthEvents = useMemo(() => {
        const m = activeDate.getMonth();
        const y = activeDate.getFullYear();
        return transformedEvents.filter((e) => {
            const d = e.start || e.end;
            const dt = new Date(d);
            return dt.getMonth() === m && dt.getFullYear() === y;
        });
    }, [transformedEvents, activeDate]);

    const navigate = (newDate) => {
        setActiveDate(newDate);
    };

    
    useEffect(() => {
        if (!containerRef.current) return;
        const node = containerRef.current;
        const calc = () => {
            const w = node.clientWidth || 0;
            const next = Math.max(60, Math.min(90, Math.floor(w / 7) - 8));
            setCellSize(next);
        };
        calc();
        const ro = new ResizeObserver(calc);
        ro.observe(node);
        return () => ro.disconnect();
    }, []);

    
    const eventStyleGetter = () => ({
        style: {
            backgroundColor: "transparent",
            border: "none",
            boxShadow: "none",
            padding: 0,
        },
    });

    const EventStrip = ({ event }) => {
        const key = (event.controlType || "").toString().toLowerCase();
        let bg = "#f3f4f6";
        let fg = "#374151";
        if (key === "preventive") { bg = "#dbeafe"; fg = "#1d4ed8"; }
        else if (key === "detective") { bg = "#efe6ff"; fg = "#6b21a8"; }
        else if (key === "corrective") { bg = "#ffedd5"; fg = "#9a3412"; }
        else if (key === "directive") { bg = "#dcfce7"; fg = "#166534"; }
        else if (key === "mitigative") { bg = "#fee2e2"; fg = "#991b1b"; }
        return (
            <div
                style={{
                    display: "inline-block",
                    width: "100%",
                    backgroundColor: bg,
                    color: fg,
                    borderRadius: 8,
                    padding: "4px 8px",
                    fontSize: 12,
                    lineHeight: "16px",
                    border: "1px solid rgba(0,0,0,0.04)",
                }}
                title={event.title}
            >
                {event.title}
            </div>
        );
    };

    const dayPropGetter = (date) => {
        const today = new Date();
        const isToday =
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate();
        if (isToday) {
            return {
                className: "rbc-day-today-soft",
                style: { backgroundColor: "rgba(59,130,246,0.12)" }, // blue-500/12
            };
        }
        return {};
    };

    return (
        <div className="calendar-container w-full mx-auto" style={{ minHeight: "calc(80vh - 100px)" }}>
            <div className="bg-white rounded-lg border border-gray-200 p-4">
                <div className="mb-3">
                    <h3 className="text-gray-900 text-lg">{currentMonthLabel}</h3>
                    <p className="text-gray-500 text-sm">{monthEvents?.length} total controls</p>
                </div>
                <div
                    ref={containerRef}
                    className="shadow-lg rounded-md"
                    style={{
                        width: "100%",
                        minHeight: `${cellSize * 5.5}px`,
                        maxHeight: "80vh",
                    }}
                >
                    <Calendar
                        localizer={localizer}
                        events={transformedEvents}
                        onSelectEvent={handleEventClick}
                        startAccessor="start"
                        endAccessor="end"
                        date={activeDate}
                        onNavigate={navigate}
                        toolbar={false}
                        eventPropGetter={eventStyleGetter}
                        dayPropGetter={dayPropGetter}
                        components={{ event: EventStrip }}
                        style={{ width: "100%", height: "100%", "--cell-size": `${cellSize}px` }}
                    />
                </div>
            </div>

            <CalendarLegend />

            <div className="bg-white rounded-lg border border-gray-200 p-6 mt-4">
                <h3 className="text-gray-900 text-base">Controls for {currentMonthLabel}</h3>
                <p className="text-gray-500 text-sm mb-6">All controls scheduled in this month</p>
                <div className="space-y-3">
                    {monthEvents.map((e, idx) => {
                        const period = e?.controlPeriod || e?.period || "";
                        const findings = Number(e?.findingNumber ?? e?.findings ?? 0);
                        const type = (e.controlType || "").toLowerCase();
                        const typeCls =
                            type === "preventive"
                                ? "pill-blue"
                                : type === "detective"
                                ? "pill-purple"
                                : type === "corrective"
                                ? "pill-orange"
                                : type === "directive"
                                ? "pill-green"
                                : "badge-soft-gray";
                        const findingsCls = isNaN(findings) || findings === 0 ? "badge-green" : "badge-red";
                        const frameworks =
                            Array.isArray(e?.complianceTypes) ? e.complianceTypes : [];
                        return (
                            <div
                                key={idx}
                                className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3"
                            >
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="text-gray-600 text-sm whitespace-nowrap">{`CTRL-${e.controlID ?? ""}`}</span>
                                        <span className="text-gray-900 truncate">{e.title}</span>
                                        {period && (
                                            <span className="badge-soft-gray text-xs">{period}</span>
                                        )}
                                        {!isNaN(findings) && (
                                            <span className={`${findingsCls} text-xs`}>
                                                {findings} findings
                                            </span>
                                        )}
                                    </div>
                                    {frameworks?.length > 0 && (
                                        <div className="flex items-center gap-2">
                                            {frameworks.map((fw, i) => (
                                                <span
                                                    key={i}
                                                    className="text-[11px] font-semibold text-gray-700"
                                                >
                                                    {fw}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-center gap-3 pl-3">
                                    {e.controlType && (
                                        <span className={`px-3 py-1 rounded text-xs ${typeCls}`}>
                                            {e.controlType}
                                        </span>
                                    )}
                                    {e.owner?.firstName || e.owner?.lastName ? (
                                        <span className="text-gray-600 text-sm whitespace-nowrap">
                                            {(e.owner?.firstName || "") + " " + (e.owner?.lastName || "")}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        );
                    })}
                    {monthEvents?.length === 0 && (
                        <div className="text-sm text-gray-500">No controls in this month.</div>
                    )}
                </div>
            </div>

             {selectedControl && (
                   <Popup
                    open={true}
                    onClose={() => setSelectedControl(null)} 
                    contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}>
                    <ControlOverlay key={selectedControl.controlID || 'new-control'} closeControl={() => setSelectedControl(null)} control_id={selectedControl.controlID} risk_id={selectedControl.riskId} />
                    </Popup>
                  )}
        </div>

        
    );
};

export default CalendarView;